export default __webpack_public_path__ + "static/CanadaForcedLaborFilingReport-26e10c17744b84008c9d09dcb62e29b4.pdf";